import { Injector } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormID } from '@finxone-platform/form-action';
import { assignMarketingPreferencesValuesToForm } from './user-profile/marketing-preferences.utils';
import { assignProfileValuesToForm } from './user-profile/user-profile-update';
import { assignSpendingBudgetValuesToForm } from '@app/finxone-web-frontend/app/lib/utils/workflow-forms-utils/spending-budget/spending-budget-form.utils';

export type WorkflowFormsActionType = (injector: Injector, formGroup: FormGroup) => void;

export const formsAssociatedWithState: Map<FormID, WorkflowFormsActionType> = new Map([
  [
    FormID.MARKETING_PREFERENCES_FORM,
    (injector: Injector, formGroup: FormGroup) => assignMarketingPreferencesValuesToForm(injector, formGroup),
  ],
  [
    FormID.UPDATE_USER_PROFILE,
    (injector: Injector, formGroup: FormGroup) => assignProfileValuesToForm(injector, formGroup),
  ],
  [
    FormID.SPENDING_BUDGET_FORM,
    (injector: Injector, formGroup: FormGroup) => assignSpendingBudgetValuesToForm(injector, formGroup),
  ],
]);
